
import React from 'react';

const EmptyRecommendations: React.FC = () => {
  return (
    <div className="text-center py-6">
      <p className="text-muted-foreground">No recommendations available.</p>
    </div>
  );
};

export default EmptyRecommendations;
